import React, { Component } from "react";

import axios from "axios";
import parse from "html-react-parser";

import { Link, withRouter } from "react-router-dom";
import PulseLoader from "react-spinners/PulseLoader";

import { copyright } from "../data/copyright";

class HtmlText extends Component {
  state = {
    progress: true,
    html: null,
    width: 0,
  };

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    this.getHtml();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.objectnr !== this.props.objectnr) {
      this.setState({ progress: true, html: null });
      this.getHtml();
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  getHtml = () => {
    axios
      .get(`${this.props.path}/${this.props.file}`)
      .then((res) => {
        var html = res.data;
        var positionTop = html.indexOf("top:", 1343) + "top:".length;
        var topValue = html.substring(
          positionTop,
          html.indexOf(";", positionTop)
        );
        document.documentElement.style.setProperty(
          "--top",
          "-" + topValue.trim()
        );
        html = html.replace(
          new RegExp(
            // eslint-disable-next-line
            '<CENTER>\n<TABLE width="80%">\n<TR>\n<TD align="left" ></TD>\n<TD align="center" ><A href=.*title="Toc">Index</A></TD>\n<TD align="right" ></TD></TR></TABLE></CENTER>\n<HR NOSHADE size=3 align=center>'
          ),
          ""
        );
        var regexSpan = /(vertical-align: super;" >)([0-9]*)(<\/SPAN>)/gi;
        html = html.replace(
          regexSpan,
          `vertical-align: super; font-size: 10px;">$2$3`
        );

        var regexOl = /<OL type="1" compact style="/gi;
        html = html.replace(
          regexOl,
          '<OL type="1" compact style="padding-left: 15px; '
        );

        var regexLi = /<LI type="1"/gi;
        html = html.replace(regexLi, '<LI type="1" style="font-size: 7.5pt;"');

        var regexP = /text-indent: [0-9]*.[0-9]*px/gi;
        html = html.replace(regexP, "text-indent: 0px");

        // console.log(html);

        html = html.replace(
          new RegExp(
            // eslint-disable-next-line
            '<HR NOSHADE size=3 align=center><CENTER>\n<TABLE width="80%">\n<TR>\n<TD align="left" ></TD>\n<TD align="center" ><A href=.*title="Toc">Index</A></TD>\n<TD align="right" ></TD></TR></TABLE></CENTER>'
          ),
          ""
        );
        var regEx = new RegExp(this.props.objectnr, "g");
        html = html.replace(regEx, `${this.props.path}/${this.props.objectnr}`);
        // html = this.setCopyright(html);
        this.setState({ progress: false, html: parse(html) });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ progress: false, html: null });
      });
  };

  setCopyright = (text) => {
    copyright.forEach((element) => {
      // var regEx = new RegExp("<LEFT>\n<IMG src=" + element, "g");
      text = text.replace(
        '<LEFT>\n<IMG src="' + element,
        '<div style="position: absolute;bottom: 0pt;font-size: 9pt;right: 0; background-color: rgba(255,255,255,0.7);">Copyright</div><LEFT><IMG src="' +
          element
      );
    });
    return text;
  };

  updateWindowDimensions = () => {
    this.setState({
      width: window.innerWidth,
    });
  };

  render() {
    return this.state.progress ? (
      <div className="spinner" style={{ height: "calc(50vh - 66px)" }}>
        <div style={{ justifyContent: "center", display: "flex" }}>
          <PulseLoader color={"#00568E"} loading={true} size={35} margin={5} />
        </div>
        <p style={{ marginTop: "20px", textAlign: "center" }}>
          Informationen werden geladen.
        </p>
      </div>
    ) : this.state.html ? (
      <div>
        {
          <div
            style={{
              width: "calc(100% / 1.4)",
              transformOrigin: "top left",
              transform: "scale(1.4)",
            }}
          >
            <div
              style={{
                justifyContent: this.state.width < 1112 ? "normal" : "center",
                position: "relative",
                display: "flex",
                flexWrap: "nowrap",
                overflowY: "hidden",
                overflowX: "auto",
              }}
            >
              {this.state.html}
            </div>
            <div
              style={{
                padding: "0 20px",
                zIndex: 1,
                position: "relative",
                transform: "scale(calc(1 / 1.4))",
                transformOrigin: "left",
                width: "calc(100% * 1.4 - 20px - 20px)", // minus padding
              }}
            >
              <div style={{ paddingBottom: "20px", textAlign: "justify" }}>
                Die angezeigten Inhalte sind ein Ausschnitt aus der Publikation
                von Christoph Mörstedt: Mühlen im Kreis Herford: Historisches
                Kataster, Bielefeld 1995. Weitere Informationen u.a. zum
                Bildnachweis finden Sie im{" "}
                <Link
                  className={"appLink"}
                  to={this.props.location.pathname + "#impressum"}
                >
                  Impressum
                </Link>
                .
              </div>
            </div>
          </div>
        }
      </div>
    ) : (
      <div style={{ marginTop: "1.25rem", padding: "0 1rem" }}>
        Es konnten keine textlichen Informationen zur ausgewählten Mühle
        gefunden werden.
      </div>
    );
  }
}

export default withRouter(HtmlText);
